import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();

  const handleClick = (path, index) => {
    if (index < items?.length - 1 && path) {
      navigate(path);
    }
  };

  return (
    <nav aria-label="Breadcrumb" className="mb-24">
      <ol className="flex items-center space-x-8 text-sm font-caption">
        {items?.map((item, index) => {
          const isLast = index === items?.length - 1;
          const isClickable = !isLast && item?.path;

          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  color="var(--color-muted-foreground)"
                  className="mx-8"
                />
              )}
              {isClickable ? (
                <button
                  onClick={() => handleClick(item?.path, index)}
                  className="text-primary hover:text-accent transition-smooth hover:underline max-w-[200px] truncate"
                  title={item?.label}
                >
                  {item?.label}
                </button>
              ) : (
                <span 
                  className={`
                    max-w-[200px] truncate
                    ${isLast ? 'text-foreground font-medium' : 'text-muted-foreground'}
                  `}
                  title={item?.label}
                >
                  {item?.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;